/* eslint-disable */
// @ts-nocheck
export const updateConsentInTagManager = (consent) => {
  if (typeof window === 'undefined') return;

  window.dataLayer = window.dataLayer || [];

  function gtag() {
    window.dataLayer.push(arguments);
  }

  gtag('consent', 'update', consent);
  /**
   * Send custom event to trigger tags based on current consent settings
   */
  gtag('event', 'consent_updated');
};
